import React from "react";
import {
  FaUmbrellaBeach as BeachIcon,
  FaPassport as VisaIcon,
  FaUtensils as CulinaryIcon,
  FaBed as UniqueStaysIcon,
  FaShip as CruiseIcon,
  FaBookOpen as TravelStoriesIcon,
  FaLandmark as AttractionsIcon,
  FaHeart as HoneymoonIcon,
  FaHeart as RomanticIcon,
  FaUsers as FamilyIcon,
  FaUserFriends as FriendsIcon,
  FaUser as SoloIcon,
  FaMapMarkerAlt as IndiaIcon,
  FaGlobe as InternationalMonthlyIcon,
  FaTag as SuperDealsIcon,
  FaCalendarAlt as IndiaMonthlyIcon,
  FaGlobe as HoneymoonGlobalIcon,
  FaFileAlt as VisaProcessIcon,
  FaWater as IslandsIcon,
  FaLightbulb as TravelTipsIcon,
  FaMountain as AdventureIcon,
  FaMountain as HillStationIcon,
  FaHiking as TrekkingIcon,
  FaCampground as CampingIcon,
  FaWater as WaterfallsIconAlt,
  FaCalendarWeek as WeekendIcon,
  FaTicketAlt as ThemeparksIcon,
  FaGem as HiddenGemsIcon,
  FaMagic as FantasyIcon,
  FaSun as DesertIcon,
  FaLeaf as NatureIcon,
  FaTree as ParksIcon,
  FaStar as WondersIcon,
  FaDrumstickBite as FestivalsIcon,
  FaCity as CityEscapesIcon,
  FaPaw as WildlifeIcon,
} from "react-icons/fa";

// ─── Category data ────────────────────────────────────────────────────────────
const categories = [
  { icon: <BeachIcon />,             text: "Season Stories",              link: "https://travel.rethinkways.com/category/seasons-stories/",         bg: "#ffe5e9", color: "#8f1f35" },
  { icon: <VisaIcon />,              text: "VISA-Free",                   link: "https://travel.rethinkways.com/category/visa-free/",               bg: "#FFF0DA", color: "#8F4F0A" },
  { icon: <CulinaryIcon />,          text: "Culinary",                    link: "https://travel.rethinkways.com/category/culinary/",                bg: "#fff4e5", color: "#87541b" },
  { icon: <UniqueStaysIcon />,       text: "Unique Stays",                link: "https://travel.rethinkways.com/category/unique-stays/",            bg: "#dcfaec", color: "#145c43" },
  { icon: <CruiseIcon />,            text: "Cruises",                     link: "https://travel.rethinkways.com/category/cruise/",                  bg: "#d8fbf2", color: "#0f6656" },
	  { icon: <TravelStoriesIcon />,     text: "Travel Stories",              link: "https://travel.rethinkways.com/travel-web-stories/",              bg: "#dbf2ff", color: "#155a82" },
  { icon: <AttractionsIcon />,       text: "Attractions",                 link: "https://travel.rethinkways.com/category/attractions/",             bg: "#e2e7ff", color: "#2e3a86" },
  { icon: <HoneymoonIcon />,         text: "Honeymoon – India",           link: "https://travel.rethinkways.com/category/honeymoon-india/",         bg: "#eae3ff", color: "#563392" },
  { icon: <RomanticIcon />,          text: "Romantic Escapes",            link: "https://travel.rethinkways.com/category/romantic-escapes/",        bg: "#ffe6f2", color: "#8e2a59" },
  { icon: <FamilyIcon />,            text: "Family Getaways",             link: "https://travel.rethinkways.com/category/family-getaways/",         bg: "#ffe9eb", color: "#933430" },
  { icon: <FriendsIcon />,           text: "Friends Trip",                link: "https://travel.rethinkways.com/category/friends/",                 bg: "#fff4d9", color: "#5a4500" },
  { icon: <SoloIcon />,              text: "Solo Travel",                 link: "https://travel.rethinkways.com/category/solo-travel/",             bg: "#ffebd5", color: "#8f4c22" },
  { icon: <IndiaIcon />,             text: "India 2026",                  link: "https://travel.rethinkways.com/category/india-2026/",              bg: "#e3ffef", color: "#1f6e4c" },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" aria-hidden="true">
        <path d="M80-80v-440h80v80h80l119-395v-85h80v80h81v-80h80v80l120 400h80v-80h80v440H520v-200h-80v200H80Zm268-440h264l-24-80H372l-24 80Zm48-160h168l-24-80H420l-24 80ZM160-160h200v-200h240v200h200v-200H660l-24-80H324l-24 80H160v200Zm320-300Z" />
      </svg>
    ),
    text: "Incredible India",
    link: "https://travel.rethinkways.com/category/india/",
    bg: "#eae6f9",
    color: "#47408a",
  },
  { icon: <InternationalMonthlyIcon />, text: "International Monthly Getaways", link: "https://travel.rethinkways.com/category/international-months/", bg: "#fff4d9", color: "#5a4500" },
	  { icon: <SuperDealsIcon />,        text: "Super Deals",                 link: "https://travel.rethinkways.com/super-deals/",  bg: "#e6f2ff", color: "#1d4f8c" },
  { icon: <IndiaMonthlyIcon />,      text: "India Monthly Getaways",      link: "https://travel.rethinkways.com/category/india-months/",            bg: "#d4f5e1", color: "#1f6b44" },
  { icon: <HoneymoonGlobalIcon />,   text: "Honeymoon – Global",          link: "https://travel.rethinkways.com/category/honeymoon-global/",        bg: "#dcf7ff", color: "#1f5f75" },
  { icon: <VisaProcessIcon />,       text: "VISA Process",                link: "https://travel.rethinkways.com/category/visa-process/",            bg: "#ffe8ef", color: "#8f3e57" },
  { icon: <IslandsIcon />,           text: "Islands",                     link: "https://travel.rethinkways.com/category/islands/",                 bg: "#e2f0ff", color: "#1e4c88" },
  { icon: <TravelTipsIcon />,        text: "Travel Tips & Essential",     link: "https://travel.rethinkways.com/category/travel-tips/",             bg: "#fff1e0", color: "#935a1c" },
  { icon: <AdventureIcon />,         text: "Adventure",                   link: "https://travel.rethinkways.com/category/adventure/",               bg: "#f1e4ff", color: "#4a2592" },
  { icon: <HillStationIcon />,       text: "Hill Station",                link: "https://travel.rethinkways.com/category/hill-stations/",           bg: "#e0fff2", color: "#206a5a" },
  { icon: <TrekkingIcon />,          text: "Trekking",                    link: "https://travel.rethinkways.com/category/trekking/",                bg: "#edffde", color: "#3e6e1f" },
  { icon: <CampingIcon />,           text: "Camping",                     link: "https://travel.rethinkways.com/category/camping/",                 bg: "#fff2dc", color: "#8f5a1d" },
  { icon: <BeachIcon />,             text: "Beaches",                     link: "https://travel.rethinkways.com/category/beaches/",                 bg: "#ffe6c7", color: "#8a3f13" },
  { icon: <WeekendIcon />,           text: "Weekend",                     link: "https://travel.rethinkways.com/category/weekend-getaways/",        bg: "#d7eaff", color: "#1e4178" },
  { icon: <ThemeparksIcon />,        text: "Themeparks",                  link: "https://travel.rethinkways.com/category/theme-parks/",             bg: "#ebf3dc", color: "#556a19" },
  { icon: <HiddenGemsIcon />,        text: "Hidden Gems",                 link: "https://travel.rethinkways.com/category/hidden-gems/",             bg: "#f7e2ff", color: "#71267c" },
  { icon: <FantasyIcon />,           text: "Fantasy",                     link: "https://travel.rethinkways.com/category/fantasy/",                 bg: "#ffe8de", color: "#8f4a1f" },
  { icon: <DesertIcon />,            text: "Deserts",                     link: "https://travel.rethinkways.com/category/desert/",                  bg: "#fff4e3", color: "#866a22" },
  { icon: <NatureIcon />,            text: "Nature",                      link: "https://travel.rethinkways.com/category/nature/",                  bg: "#e4f9f0", color: "#1e6a58" },
  { icon: <ParksIcon />,             text: "Parks",                       link: "https://travel.rethinkways.com/category/parks/",                   bg: "#eae6f9", color: "#47408a" },
  { icon: <WondersIcon />,           text: "Wonders",                     link: "https://travel.rethinkways.com/category/world-wonders/",           bg: "#e5e7ff", color: "#343c96" },
  { icon: <FestivalsIcon />,         text: "Festivals",                   link: "https://travel.rethinkways.com/category/festivals/",               bg: "#f4e2f7", color: "#71367c" },
  { icon: <CityEscapesIcon />,       text: "City Escapes",                link: "https://travel.rethinkways.com/category/city/",                   bg: "#e9fff4", color: "#1f6e55" },
  { icon: <WaterfallsIconAlt />,     text: "Waterfalls",                  link: "https://travel.rethinkways.com/category/waterfalls/",              bg: "#ffe7eb", color: "#8A2f44" },
  { icon: <WildlifeIcon />,          text: "Wildlife",                    link: "https://travel.rethinkways.com/category/wildlife/",                bg: "#dbfff6", color: "#146b5e" },
];

// ─── Main component ───────────────────────────────────────────────────────────
export default function CategoryPills({ darkMode }) {
  return (
    <div className="w-full max-w-[1500px] mx-auto px-4 lg:px-5 xl:px-6 font-poppins">
      
      {/* Adjusted the gap scaling: tighter on mobile (gap-2.5) scaling up to desktop (gap-4).
      */}
      <div className="flex flex-wrap gap-2.5 sm:gap-3 md:gap-3.5 lg:gap-4 justify-center xl:justify-start">
        {categories.map(({ icon, text, bg, color, link }, idx) => (
          
          <a key={idx} href={link} className="inline-flex shrink-0">
            <div
              style={{ background: bg, color }}
              className={`inline-flex items-center 
                gap-1.5 sm:gap-2 lg:gap-2.5
                px-3 sm:px-4 
                py-1.5 sm:py-2
                rounded-lg sm:rounded-[10px]
                text-[13px] xs:text-[14px] sm:text-[15px] lg:text-[17px]
                font-medium whitespace-nowrap cursor-pointer
                transition-opacity duration-300
                ${darkMode ? "opacity-85 hover:opacity-100" : "hover:opacity-90"}`}
            >
              <span className="text-[14px] sm:text-[15px] lg:text-[16px] flex-shrink-0">
                {icon}
              </span>
              {text}
            </div>
          </a>
          
        ))}
      </div>
    </div>
  );
}
